var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { ref, watch, onMounted, onUnmounted, nextTick } from "vue";
function getPureContentWidth(el) {
  const style = getComputedStyle(el), { width: totalWidth } = el.getBoundingClientRect(), paddingLeft = Number.parseFloat(style.paddingLeft), paddingRight = Number.parseFloat(style.paddingRight), borderLeft = Number.parseFloat(style.borderLeftWidth), borderRight = Number.parseFloat(style.borderRightWidth), gap = Number.parseFloat(style.columnGap);
  return {
    rawWidth: totalWidth - paddingLeft - paddingRight - borderLeft - borderRight,
    space: gap
  };
}
__name(getPureContentWidth, "getPureContentWidth");
function useHideOverflowingTags({ hideOverflowingTags, selectedTags }) {
  const isHiddenTagsPopoverContentOpenRef = ref(!1);
  let popoverContentOpenTimer = null;
  function handlePopoverContentOpenMouseEnter() {
    popoverContentOpenTimer !== null && clearTimeout(popoverContentOpenTimer), isHiddenTagsPopoverContentOpenRef.value = !0;
  }
  __name(handlePopoverContentOpenMouseEnter, "handlePopoverContentOpenMouseEnter");
  function handlePopoverContentCloseMouseLevel() {
    popoverContentOpenTimer = setTimeout(() => {
      isHiddenTagsPopoverContentOpenRef.value = !1;
    }, 350);
  }
  __name(handlePopoverContentCloseMouseLevel, "handlePopoverContentCloseMouseLevel");
  const containerRef = ref(), ctrlHideOverflowingTagsRenderRef = ref(!1), tagsRef = ref([]), moreRef = ref(), displayTagsLengthRef = ref(0), hiddenTagsLengthRef = ref(0);
  function tagInstanceRef(instance, i) {
    tagsRef.value[i] = instance == null ? void 0 : instance.element;
  }
  __name(tagInstanceRef, "tagInstanceRef");
  function calculateTagsNeedHidden() {
    var _a;
    if (!containerRef.value)
      return;
    const { rawWidth: containerWidth, space } = getPureContentWidth(containerRef.value);
    let displayLength = 0;
    if (tagsRef.value.length < 2)
      displayLength = tagsRef.value.length;
    else
      for (let i = 0, w = 0; i < tagsRef.value.length; i++) {
        const e = (_a = tagsRef.value) == null ? void 0 : _a[i];
        if (e && (w += e.getBoundingClientRect().width + (i === 0 ? 0 : space)), w >= containerWidth)
          break;
        displayLength += 1;
      }
    displayTagsLengthRef.value = displayLength, hiddenTagsLengthRef.value = selectedTags.value.length - displayLength;
  }
  __name(calculateTagsNeedHidden, "calculateTagsNeedHidden");
  function calculateAppropriateWidth(p) {
    var _a;
    if (!(containerRef.value && ((_a = moreRef.value) != null && _a.element)))
      return;
    const pureContentWidth = p ?? getPureContentWidth(containerRef.value), { rawWidth: containerWidth, space } = pureContentWidth, { width: moreWidth } = moreRef.value.element.getBoundingClientRect();
    let width = moreWidth, needRerender = !0;
    for (let i = 0; i < displayTagsLengthRef.value; i++) {
      const tag = tagsRef.value[i];
      if (!tag)
        continue;
      const { width: tagWidth } = tag.getBoundingClientRect();
      if (width += tagWidth + space, width > containerWidth) {
        needRerender = !1, displayTagsLengthRef.value -= 1, hiddenTagsLengthRef.value += 1, calculateAppropriateWidth(pureContentWidth);
        break;
      }
    }
    needRerender && (ctrlHideOverflowingTagsRenderRef.value = needRerender);
  }
  __name(calculateAppropriateWidth, "calculateAppropriateWidth");
  async function calculate() {
    ctrlHideOverflowingTagsRenderRef.value = !1, await nextTick(calculateTagsNeedHidden), await nextTick(calculateAppropriateWidth);
  }
  __name(calculate, "calculate"), watch(() => selectedTags.value, () => {
    hideOverflowingTags.value && calculate();
  }), watch(hiddenTagsLengthRef, (newHiddenTagsLength) => {
    hideOverflowingTags.value && newHiddenTagsLength <= 0 && (isHiddenTagsPopoverContentOpenRef.value = !1);
  });
  let resizeObserver = null, containerWidthCache = null;
  return onMounted(() => {
    hideOverflowingTags.value && containerRef.value && (calculate(), resizeObserver = new ResizeObserver((entryArray) => {
      const { width } = entryArray[0].contentRect;
      width !== containerWidthCache && containerWidthCache !== null && calculate(), containerWidthCache = width;
    }), resizeObserver.observe(containerRef.value));
  }), onUnmounted(() => {
    hideOverflowingTags.value && resizeObserver && (resizeObserver.disconnect(), resizeObserver = null);
  }), {
    containerRef,
    ctrlHideOverflowingTagsRenderRef,
    moreRef,
    displayTagsLengthRef,
    hiddenTagsLengthRef,
    isHiddenTagsPopoverContentOpenRef,
    tagInstanceRef,
    handlePopoverContentOpenMouseEnter,
    handlePopoverContentCloseMouseLevel
  };
}
__name(useHideOverflowingTags, "useHideOverflowingTags");
export {
  useHideOverflowingTags
};
//# sourceMappingURL=useHideOverflowingTags.js.map
